<script setup lang="ts">
import type { CustomerDto } from '@/types';
import { ref } from 'vue';
import axios from 'axios';
import InputCardComponent from '@/components/InputCardComponent.vue';

const customerForm = defineModel<Partial<CustomerDto>>({ required: true })

const emit = defineEmits<{
  found: [customerId: number]
  notFound: []
}>()

const rules = ref({
  required: (value: unknown) => !!value || "Påkrævet",
  name: (value: string) =>
    (!!value &&
      value.split(" ").length >= 2 &&
      value
        .split(" ")
        .every((x) => /^[a-zA-Z0-9\u00c0-\u017e.:/-]+$/.test(x))) ||
    "Skal bestå af minimum 2 navne.",
  email: (value: string) =>
    /^[^\W_]+(?!.*([\W_]{2}|[\W_]@|@[\W_]))[\w-.]*@[\w-.]+\.[a-z]{2,5}$/i.test(value) ||
    "Skal indeholde et @ og slutte på .dk, .com e.lign.",
  mobile: (value: string) =>
    /^[\d]{8}$/.test(value) ||
    "Må kun indeholde tal og skal være 8 cifre.",
})

async function getCustomer(focused: boolean) {
  if (!focused && customerForm.value.email && rules.value.email(customerForm.value.email) === true) {
    try {
      const { data } = await axios.get(`proxy/customers?email=${customerForm.value.email}`)

      if (data.length) {
        // Only name and phone. The saved address is not reliable, so it is always picked in AddressInfoComponent
        customerForm.value.name = data[0].name
        customerForm.value.mobile = data[0].mobile
        emit('found', data[0].id)
      }
      else {
        emit('notFound')
      }
    } catch (error) {
      console.error(error)
    }
  }
}
</script>

<template>
  <InputCardComponent label="Kontaktoplysninger">
    <v-text-field
      v-model="customerForm.email"
      label="Email"
      name="email"
      type="email"
      :rules="[rules.required, rules.email]"
      clearable
      @update:focused="getCustomer"
    />
    <v-text-field
      v-model="customerForm.name"
      label="Navn"
      name="name"
      type="text"
      :rules="[rules.required, rules.name]"
      clearable
    />
    <v-text-field
      v-model="customerForm.mobile"
      label="Telefon"
      prefix="+45"
      name="mobile"
      type="tel"
      :rules="[rules.required, rules.mobile]"
      clearable
    />
  </InputCardComponent>
</template>
